// extracted by mini-css-extract-plugin
module.exports = {"container":"gW","image":"gX","title":"gY","date":"gZ"};